import { AuthenticateResponse, DefaultThemeOptions, GetClientConfigurationResponse, OpenIddictFeature, ThemeName } from "@ngt/openiddict";
import logo from '@/assets/img/logo-small.png';
import { responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";
import { parse } from "qs";


declare let global: any;

if (typeof global === 'undefined') {
    (window as any).global = window;
}

const authentication: AuthenticateResponse | null = global.AUTH ?? null;
const clientConfiguration: GetClientConfigurationResponse | null = global.OPEN_ID_DICT;
const administrationGroup: string | null = global.ADMINISTRATION_GROUP;

const queryParams = parse(location.search, { ignoreQueryPrefix: true });
let override: string = (queryParams.theme ?? queryParams.Theme) as string;

const redirectQueryString = [
    'redirecturl',
    'returnurl',
    'returnuri'
];

if (!override) {
    const redirectUrlKey = Object.keys(queryParams).find(x => redirectQueryString.includes(x.toLowerCase()));

    const redirectUrl = redirectUrlKey ? queryParams[redirectUrlKey] as string : undefined;
    
    if (redirectUrl && redirectUrl.includes('?')) {
        
        const redirectQueryParams = parse(redirectUrl.substring(redirectUrl.indexOf('?')), { ignoreQueryPrefix: true });

        override = (redirectQueryParams.theme ?? redirectQueryParams.Theme) as string;
    }
}

const overrideTheme: ThemeName | undefined = 'light';//override === 'dark' || override === 'light' ? override as ThemeName : undefined;

const primaryColorLight = '#00447a';
const secondaryColorLight = '#fea002';
const primaryColorDark = '#4a779b';
const secondaryColorDark = '#a44b80';
const primaryColorMoreDark = '#584b66';
const secondaryColorMoreDark = '#be892f';

const formsFeature = new OpenIddictFeature({
    name: 'Login',
    branding: {
        name: 'TROG Cancer Research',
        logo: logo
    },
    client: {
        baseUrl: import.meta.env.VITE_API_URL,
        basePath: '/ss-api',
        client: undefined
    },
    theme: {
        overrideTheme: overrideTheme,
        beforeThemeCreated: (themeOptions, chosenTheme) => {
            const newOptions = {
                ...themeOptions,
                palette: {
                    ...themeOptions.palette,
                    primary: {
                        main: chosenTheme === 'dark' ? primaryColorDark : primaryColorLight
                    },
                    secondary: {
                        main: chosenTheme === 'dark' ? secondaryColorMoreDark : secondaryColorLight 
                    }
                }
            };

            if (chosenTheme !== 'dark') {
                newOptions.palette.background = {
                    default: grey[200]
                }
            }

            return newOptions;
        },
        afterThemeCreated: (theme, chosenTheme) => {
            return responsiveFontSizes(theme);
        },
        themeOptions: DefaultThemeOptions
    },
    initialAuthentication: authentication,
    initialClientConfiguration: clientConfiguration,
    contacts: {
        administrator: 'membership@trog.com.au'
    },
    isAdminFn: (openIddict, clientConfiguration, auth) => {
        if (clientConfiguration?.administrationGroup) {
            return auth?.roles?.includes(clientConfiguration.administrationGroup) === true;
        }

        return false;
    }
});

export default formsFeature;